
export default function Borders() {
    return (
        <div id="wd-css-borders">
            <h2>Borders</h2>
            <p className="wd-border-fat wd-border-red wd-border-solid">
                Solid fat red border
            </p>
            <p className="wd-border-thin wd-border-blue wd-border-dashed">
                Dashed thin blue border
            </p>
        </div>
    );
}
